import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CFIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CF" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0h16v3H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 3h16v3H0V3Z"
        clipRule="evenodd"
      />
      <Path
        fill="#73BE4A"
        fillRule="evenodd"
        d="M0 6h16v3H0V6Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FFD018"
        fillRule="evenodd"
        d="M0 9h16v3H0V9Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="m2.265 2.708-1.213.84.388-1.44-.89-.92 1.205-.049.51-1.424.51 1.424h1.203l-.888.97.444 1.355-1.27-.756Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E11C1B"
        fillRule="evenodd"
        d="M6.4 0h3.2v12H6.4V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
